import React, { useRef } from 'react';
import { ReactComponent as InfoIcon } from '../../../assets/images/info-i-icon.svg';
import { ReactComponent as QuestionInfoIcon } from '../../../assets/images/info-icon.svg';
import styles from './InfoTooltip.module.css';
import ReactTooltip from 'react-tooltip';
import { Button } from 'reactstrap';

const InfoTooltip = ({ iconType, message, icon, id }) => {
    const tooltipRef = useRef();
    return (
        <div className={styles.onsiteInfo}>
            <Button
                className={styles.tooltipButton}
                onClick={(e) => { ReactTooltip.show(tooltipRef.current) }}
                onFocus={(e) => { ReactTooltip.show(tooltipRef.current) }}
                onBlur={(e) => { ReactTooltip.hide(tooltipRef.current) }}
                onKeyDown={(e) => {e.keyCode === 27 && ReactTooltip.hide(tooltipRef.current)}}
            >
                <span ref={tooltipRef}
                    data-tip
                    data-for={`info-tooltip-${id}`} role="tooltip">
                    {iconType === "question" ? <QuestionInfoIcon /> : <InfoIcon />}
                </span>
            </Button>
            <ReactTooltip
                id={`info-tooltip-${id}`}
                tabIndex="0"
                clickable="true"
                aria-haspopup='true'
                className={styles.tooltiptext}
                effect="solid"
                type="light"
                place={"bottom", "right"}
                border={true}
            >
                <span className={styles.toolTipSvg}>{icon}</span>
                {message}
            </ReactTooltip>
        </div>
    )
}
export default InfoTooltip;